import { NAV_ITEMS } from '@/lib/layout.config';
import { SidebarNavItem } from '@/shared/components/Layout/SidebarNavItem/SidebarNavItem';
import { SCROLLER_CLASSES } from '@/shared/components/ui/scroll/scroll.tokens';

export interface SidebarNavProps {
  /** Collapsed rail: icons only, labels carried by the accessible name. */
  isCollapsed: boolean;
}

/**
 * The navigation list itself, extracted from `Sidebar` so the persistent rail and
 * the mobile drawer render the SAME items from the SAME config.
 *
 * The alternative — a drawer with its own copy of the list — is how a phone
 * operator ends up with a menu that quietly lost an entry, and how the N22
 * gating in `SidebarNavItem` drifts between two surfaces. There is one nav; it
 * has two hosts.
 */
export function SidebarNav({ isCollapsed }: SidebarNavProps) {
  return (
    <nav className={SCROLLER_CLASSES}>
      <ul className="flex flex-col gap-xs">
        {NAV_ITEMS.map((item) => (
          <SidebarNavItem key={item.to} item={item} isCollapsed={isCollapsed} />
        ))}
      </ul>
    </nav>
  );
}
